module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"content":"License du projet"},"en":{"content":"Project License"}}')
  delete Component.options._Ctor
}
